module.exports = __webpack_public_path__ + "img/2.9303cfb3.jpg";